<template>
  <a :href="link" target="_blank" rel="noopener noreferrer">
    <img :src="iconPath" :alt="rede">
  </a>
</template>

<script setup>
import { computed } from 'vue'
import facebookIcon from '@/assets/images/icone-facebook.svg'
import instagramIcon from '@/assets/images/icone-instagram.png'
import whatsappIcon from '@/assets/images/icone-whatsapp.png'

const props = defineProps({
  rede: {
    type: String,
    required: true,
    validator: (value) => ['facebook', 'instagram', 'whatsapp'].includes(value)
  },
  link: {
    type: String,
    required: true
  }
})

const icons = {
  facebook: facebookIcon,
  instagram: instagramIcon,
  whatsapp: whatsappIcon
}

const iconPath = computed(() => icons[props.rede])
</script>

<style scoped>
a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 10px;
  background-color: #2280b4;
  margin: 0 0 0 10px;
}
a:hover {
  background-color: #103e7f;
}
a img {
  width: 100%;
  max-width: 25px;
}
</style> 